var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa-stack clickable",on:{"click":function($event){return _vm.toTop()}}},[_c('i',{staticClass:"fa-stack-2x fas fa-square c-blue"}),_c('i',{class:"fa-stack-1x fas fa-home"})])])}
var staticRenderFns = []

export { render, staticRenderFns }